module.exports = __webpack_public_path__ + "img/Picture26.c8772384.png";